import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConnectionImportRow, ConnectionsImportResult } from '../models/connection-import.model';
import { RestUtils } from './rest-utils';

@Injectable()
export class ConnectionsImportService {
  http: HttpClient;

  utils = new RestUtils();

  headers = new HttpHeaders();

  constructor(http: HttpClient) {
    this.http = http;
    this.headers = this.headers.set('Content-Type', 'application/json');
  }

  import(rows: ConnectionImportRow[]): Observable<ConnectionsImportResult> {
    const url = this.utils.buildUrl(`ROLE/ntc/sessions-suppliers/upload`);
    const options = this.utils.getHttpHeaderOptions(this.headers);

    return this.http.post<ConnectionsImportResult>(url, rows, options);
  }

  getImportExampleFileUrl() {
    return window.location.origin + '/templates/import_sessions_suppliers.xlsx';
  }
}
